import './VerificationItemSkeleton.css';

export default function VerificationItemSkeleton({ index }: { index: number }) {
	return (
		<li className="verification-item-skeleton skeleton">
			<h3>
				<div className="verification-left">
					<strong className="index">{index || '?'}</strong>
					<span className="skeleton-element" />
				</div>
				<div className="verification-badges">
					<span className="skeleton-element" />
					<a className="skeleton-element" />
				</div>
			</h3>
		</li>
	);
}
